module.exports = __webpack_public_path__ + "assets/media/day30.2b8b08e7.mp3";